module.exports = __webpack_public_path__ + "assets/images/BBD5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BBD5.png
// module id = 1312
// module chunks = 1